module.exports = __webpack_public_path__ + "static/media/Booking-Order.31eb3c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/booking/Booking-Order.png
// module id = 98
// module chunks = 0